import type React from 'react';

import { PostHogProvider } from 'posthog-js/react';

import { env } from '@/constants/env';

export const PosthogProvider = ({ children }: React.PropsWithChildren) => {
  if (import.meta.env.MODE === 'development') {
    return children;
  }

  return (
    <PostHogProvider
      apiKey={env.PUBLIC_POSTHOG_KEY}
      options={{
        api_host: env.PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        debug: import.meta.env.MODE === 'development',
      }}
    >
      {children}
    </PostHogProvider>
  );
};
